import React from "react";

export default function Ex1_Intro() {
  return (
    <div>
      <h1>Ex1_Intro</h1>
      <p>This is the Ex1_Intro component.</p>
    </div>
  );
}
